import z from "zod/v4";
import { TenantIdCodec, SiteIdCodec, AssetIdCodec, CameraIdCodec } from "@visioni/a3s-schema/codecs";

/** A single camera within an asset's camera set. */
export const CameraEntry = z.object({
  camera: CameraIdCodec,
  friendlyName: z.string().nullable(),
});
export type CameraEntry = z.infer<typeof CameraEntry>;

/** Replaces the full camera set for one installed asset. */
export const CameraChangeSet = z.object({
  action: z.literal("set"),
  tenant: TenantIdCodec,
  site: SiteIdCodec,
  asset: AssetIdCodec,
  cameras: z.array(CameraEntry),
});
export type CameraChangeSet = z.infer<typeof CameraChangeSet>;

/** Signals that an asset's allocation has been removed — delete the record. */
export const CameraChangeRemove = z.object({
  action: z.literal("remove"),
  tenant: TenantIdCodec,
  site: SiteIdCodec,
  asset: AssetIdCodec,
});
export type CameraChangeRemove = z.infer<typeof CameraChangeRemove>;

/** A camera change event: either a full set replacement or a removal. */
export const CameraChange = z.discriminatedUnion("action", [CameraChangeSet, CameraChangeRemove]);
export type CameraChange = z.infer<typeof CameraChange>;
